import React, { useRef, useEffect } from "react";

export function PiPOverlay({ video, yaw, pitch, fov, onClose }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current && video) {
      videoRef.current.srcObject = video.srcObject;
      videoRef.current.play().catch(() => {});
    }
  }, [video]);

  return (
    <div 
      className="cam360-pip-overlay"
      style={{
        position: 'absolute',
        top: '16px',
        right: '200px',
        width: '200px',
        height: '150px',
        background: 'black',
        border: '2px solid rgba(255,255,255,0.3)',
        borderRadius: '8px',
        overflow: 'hidden',
        zIndex: 10
      }}
    >
      <video
        ref={videoRef}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
        autoPlay
        muted
        playsInline
      />
      
      <button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '4px',
          right: '4px',
          background: 'rgba(0,0,0,0.7)',
          border: 'none',
          color: 'white',
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          cursor: 'pointer',
          fontSize: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        ×
      </button>
      
      <div style={{
        position: 'absolute',
        bottom: '4px',
        left: '4px',
        background: 'rgba(0,0,0,0.7)',
        color: 'white',
        padding: '2px 6px',
        borderRadius: '4px',
        fontSize: '10px'
      }}>
        PiP View
      </div>
    </div>
  );
}
